// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"aboutWidget-module--widgetContainer--Drix8","widgetHeading":"aboutWidget-module--widgetHeading--2QHBO"};